import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KlaHttpService } from '../../shared/tools/services/kla.http.service';
import { Image, KlaLogo } from '../../shared/tools/services/kla.data.models';
import { DataService } from '../../shared/services/data.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'kla-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss', '../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, RouterModule ]
})

export class V4MenuComponent implements OnInit, AfterViewInit {

  public data: Array<any>;
  public logoImagePath: string;
  public defaultUrl: string;

  public isPreview: boolean;
  public isMaintenance: boolean;
  public menuItems: any[] = [];

  constructor(
    private dataService: DataService,
    private httpService: KlaHttpService,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId,
    ) {

    let previousPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (window.opener) {
      window.addEventListener('message', ($event) => {
        if ($event.origin.includes('kla-') || $event.origin.includes('localhost')) {
          this.loadData();
        }
      });
    }

    if (window.innerWidth < 767) {
      window.addEventListener('click', ($event: any) => {
        if ($event.target && $event.target.className && !$event.target.className.includes('open-menu')) {
          this.menuActive = false;
        }
      });
      window.addEventListener('touchstart', ($event: any) => {
        if ($event.targetTouches[0].target && $event.targetTouches[0].target.className && !$event.targetTouches[0].target.className.includes('open-menu')) {
          this.menuActive = false;
        }
      });
    }

    // header scroll event
    window.onscroll = function () {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (previousPosition > currentPosition || (previousPosition <= 0 || currentPosition <= 0)) {
        document.querySelector('.header').classList.add('header--active');
      } else {
        document.querySelector('.header').classList.remove('header--active');
      }

      previousPosition = currentPosition;
    };
  }

  filter = '';
  menuActive = false;
  showMenu = false;
  logo: KlaLogo;

  @ViewChild('input', {static: true})
  public input: ElementRef;

  ngOnInit() {
    this.loadData();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isMaintenance = DataService.isMaintenance;
    }, 3000);
    this.isMaintenance = DataService.isMaintenance;
  }

  loadData() {
    this.menuItems = DataService.HEADER_MENU_ITEMS;

    if (!DataService.getData().default) {
      this.data = DataService.getData().pages.filter(page => page.isEnabled && page.layout !== 'news-and-events');
      this.showMenu = DataService.getData().showMenu;
      this.logo = DataService.getData().logo;
    } else {
      this.data = DataService.getData().default.pages.filter(page => page.isEnabled && page.layout !== 'news-and-events');
      this.showMenu = DataService.getData().default.showMenu;
      this.logo = DataService.getData().default.logo;
    }
    const imageConfig: Image = {
      id: this.logo.image,
      width: 500,
      height: +this.logo.height,
      crop_config: this.logo.crop_config
    };
    if (this.logo.image !== 'null') {
      if(isPlatformBrowser(this.platformId)) {
        this.logoImagePath = this.httpService.getCroppedImagePath(imageConfig);
      }
    } else {
      this.logoImagePath = '';
    }
    this.defaultUrl = DataService.DEFAULT_PAGE_URL;
    this.isPreview = DataService.isLivePreview;
    this.isMaintenance = DataService.isMaintenance;
  }

  toggleClassMenu() {
    this.menuActive = !this.menuActive;
  }

  getTargetValue(layout) {
    let pages = DataService.getData().default?.pages ? DataService.getData().default?.pages : DataService.getData().pages;
    let externalPage = pages?.find(page => page.layout == layout);
    if(externalPage.targetBlank) {
      return '_blank'
    } else return '_self'
  }


}
